// src/ErrorScreen.jsx
import React, { useState } from 'react'; 
import { useNavigate, useLocation } from 'react-router-dom';
import { XCircle, AlertCircle, WifiOff } from 'lucide-react';
import ReportIssueModal from './components/ReportIssueModal'; 

export default function ErrorScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isReportModalVisible, setIsReportModalVisible] = useState(false); 

  const lastDriverId = location.state?.driverId;
  const errorType = location.state?.errorType || 'validation'; // Padrão para 'validation' por segurança

  const errorContent = {
    validation: {
      icon: <XCircle size={80} className="text-red-500" />,
      title: "Foto Recusada. Tente Novamente!",
      message: "A imagem não atendeu aos critérios mínimos de qualidade definidos."
    },
    connection: {
      icon: <WifiOff size={80} className="text-orange-500" />,
      title: "Falha de Conexão",
      message: "Não foi possível conectar ao servidor. Verifique sua internet e tente novamente."
    }
  };

  const currentError = errorContent[errorType];

  const handleNormalRetry = () => {
    sessionStorage.removeItem('lastDriverId');
    navigate('/photo');
  }
  
  const handleRetrySameDriver = () => {
    navigate('/photo', { state: { prefillDriverId: lastDriverId } });
  }

  return (
    <div className="relative min-h-screen bg-white flex flex-col justify-center items-center text-center px-6">
      <div className="mb-6">
        {currentError.icon}
      </div>
      <h1 className="text-2xl font-bold text-gray-800 mb-2">
        {currentError.title}
      </h1>
      <p className="text-gray-500 mb-8">
        {currentError.message}
      </p>

      <div className="w-full max-w-sm space-y-3">
        {lastDriverId && (
          <button
            onClick={handleRetrySameDriver}
            className="w-full bg-[#EE4D2D] text-white font-bold py-3 rounded-lg hover:bg-[#D03F2A] transition-colors"
          >
            Tentar novamente para o Driver ID {lastDriverId}
          </button>
        )}
        <button
          onClick={handleNormalRetry}
          className="w-full bg-[#EE4D2D] text-white font-bold py-3 rounded-lg hover:bg-[#D03F2A] transition-colors"
        >
          Enviar Nova Foto
        </button>
        <button
          onClick={() => navigate('/home', { state: { fromPhoto: true } })}
          className="w-full bg-white text-[#EE4D2D] font-bold py-3 rounded-lg border-2 border-[#EE4D2D] hover:bg-red-50 transition-colors"
        >
          Voltar Para Home
        </button>
      </div>
      
      {/* O modal de reportar problema não precisa de alterações */}
      <button
        onClick={() => setIsReportModalVisible(true)}
        className="fixed bottom-6 right-6 bg-[#EE4D2D] text-white p-3 rounded-full shadow-lg hover:bg-[#D03F2A] transition-all duration-300 z-40 opacity-80 hover:opacity-100"
        title="Relatar um Problema"
      >
        <AlertCircle size={24} />
      </button>

      <ReportIssueModal
        isVisible={isReportModalVisible}
        onClose={() => setIsReportModalVisible(false)}
        screenName="error"
      />
    </div>
  );
}